import React from "react";
import styled from "styled-components";
import { fonts, colors, links } from "../common/mixins.js";
import Icon from "../common/Icon.jsx";
import { formatDate } from "../common/helpers.js";
import useModal from "../../hooks/useModal";
import Overlay from "../common/Overlay";
import useMediaQuery from '@mui/material/useMediaQuery';

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  gap: ${(props) => `${props.gap}px`};
  align-items: center;
  margin-bottom: ${(props) => `${props.margin}px`};
`;

const MapText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "pf_highway_sans_pro_lightRg";
  font-size: 14px;
  color: ${colors.primary};
  cursor: pointer;

  &:hover {
    color: ${colors.linkHovered};        
  }
`;

const Small = styled.div`
  ${fonts.normalTextSmall()};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const IconContainer = styled.div`
  flex-shrink: 0;
`;

const DateLocation = ({ dateLocation, gap, margin, type, hasWeekday }) => {
  const isDrawer = useMediaQuery('(max-width:900px)');
  const {
    date,
    customDate,
    customTime,
    location,
    culture,
    mapUrl,
    venueName,
    isStreaming,
  } = dateLocation;
  const { isOpen, openModal, closeModal } = useModal();

  const formattedDate = formatDate({
    date,
    culture,
    customDate,
    customTime,
    hasWeekday,
  });
    const online = location.toLowerCase().includes('online');
   
  return (
    <>
      <FlexContainer gap={gap} margin={0}>
        <IconContainer>
          <Icon kind="date" />
        </IconContainer>
        <Small id="date">{formattedDate}</Small>
      </FlexContainer>
      <FlexContainer gap={gap} margin={0}>
        <IconContainer>
          {" "}
          <Icon kind="location" />{" "}
        </IconContainer>
        {type === "card" || isStreaming ||online ? (
          <Small id="location">{location}</Small>
        ) : (
            <MapText id="location"
            onClick={(e) => {
              e.preventDefault();
              openModal();
            }}
          >
            {location}
          </MapText>
        )}
      </FlexContainer>

      <Overlay
        handleClose={closeModal}
        open={isOpen}
        id="order-details-map-overlay"
        titleText={playdetailsv2_resources.VenueLocationMaps}
      >
        <div
          style={{
            marginBottom: 8,
            fontSize: 14,
            fontFamily: "pf_highway_sans_pro_lightRg",
          }}
        >
          {venueName}
        </div>
        <iframe
          className="r_googleMaps"
          style={{height: isDrawer ? 300 : 500, borderRadius: 8}}
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
          loading="eager"
          src={mapUrl}
        ></iframe>
      </Overlay>
    </>
  );
};

export default DateLocation;
